<template>
    <svg v-if="props.isPlay" width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="48" cy="48" r="48" fill="#464646" fill-opacity="0.5" />
        <path d="M35.1564 66.6442C35.6234 67.0148 36.0904 67.2001 36.5574 67.2001C37.0245 67.2001 37.4915 67.0148 37.9585 66.6442L60.9985 50.8951C61.7769 50.3393 62.3996 49.2276 62.3996 47.9306C62.3996 46.6336 61.9326 45.5219 60.9985 44.966L37.9585 29.2169C37.0245 28.6611 35.9347 28.6611 35.0007 29.2169C34.2223 29.7728 33.5996 30.8845 33.5996 32.1815V63.6797C33.5996 64.9766 34.2223 66.0883 35.1564 66.6442Z" fill="white" />
    </svg>
    <svg v-else width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="48" cy="48" r="48" fill="#464646" fill-opacity="0.5" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M38.456 28.8C36.8342 28.8 35.5195 30.1147 35.5195 31.7365V64.2636C35.5195 65.8853 36.8342 67.2 38.456 67.2C40.0778 67.2 41.3925 65.8853 41.3925 64.2636V31.7365C41.3925 30.1148 40.0778 28.8 38.456 28.8ZM57.543 28.8C55.9213 28.8 54.6065 30.1147 54.6065 31.7365V64.2636C54.6065 65.8853 55.9213 67.2 57.543 67.2C59.1648 67.2 60.4795 65.8853 60.4795 64.2636V31.7365C60.4795 30.1148 59.1648 28.8 57.543 28.8Z" fill="white" />
    </svg>
</template>

<script setup lang="ts">
    const props = defineProps({
        isPlay: {
            type: Boolean,
            required: true
        }
    });
</script>
